import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/button";

const RemoveModal = ({ isRemoveOpen, closeRemoveModal }) => {
  return (
    <Modal show={isRemoveOpen} onHide={closeRemoveModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Remove Subscription</Modal.Title>
      </Modal.Header>
      <Modal.Body></Modal.Body>
      <Modal.Footer>
        <Button text="Close" callBack={closeRemoveModal} />
      </Modal.Footer>
    </Modal>
  );
};

export default RemoveModal;
